import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { 
  Badge,
  Button,
  Popover,
  Typography,
} from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

interface FilterComponentProps {
  listOfFilter: boolean[]
  resetEnabledFilterOption: () => void
  children: ReactNode;
}


const FilterComponent = ({ listOfFilter, resetEnabledFilterOption, children } : FilterComponentProps) => {
  const [enabledFiltersAnchorEl, setEnabledFiltersAnchorEl] =
    useState<null | HTMLElement>(null);
  const [enabledFiltersIconRotation, setEnabledFiltersIconRotation] = useState<number>(0);
  const [enabledFilters, setEnabledFilters] = useState<boolean[]>([]);
  const enabledFiltersOpen = Boolean(enabledFiltersAnchorEl);

  useEffect(() => {
    setEnabledFilters(listOfFilter);
  }, [listOfFilter]);
  
  const handleEnabledFilterClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setEnabledFiltersAnchorEl(event.currentTarget);
    setEnabledFiltersIconRotation(enabledFiltersIconRotation === 0 ? 180 : 0);
  };

  const handleEnabledFilterClose = () => {
    setEnabledFiltersAnchorEl(null);
    setEnabledFiltersIconRotation(0);
  };

  return (
    <>
      {enabledFilters.filter(Boolean).length !== 0 &&
          <Button
            variant='text'
            sx={{
              color: '#878787',
              fontSize: 14,
              textTransform: 'none',
              fontWeight: 400,
            }}
            onClick={resetEnabledFilterOption}
          >
            Clear filters
          </Button>
      }
      <Button
        variant='outlined'
        sx={{
          borderRadius: '6px',
          border: enabledFiltersOpen ? '1px solid #181818' : '1px solid #D1D1D1',
          backgroundColor: 'white',
          padding: '5px 10px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          margin: '0px 4px 0px 4px',
          '&:hover': {
            border: '1px solid #181818',
          },
        }}
        onClick={handleEnabledFilterClick}
        endIcon={
          <ExpandMoreIcon
            style={{
              color: '#878787',
              padding: '0',
              transform: `rotate(${enabledFiltersIconRotation}deg)`,
            }}
            fontSize='small'
          />
        }
      >
        <Typography
          sx={{
            color: 'var(--grey-white-background, #878787)',
            fontFamily: 'Schibsted Grotesk',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            textTransform: 'none',
          }}
        >
          <FormattedMessage defaultMessage='Filters' />
          {enabledFilters.filter(Boolean).length !== 0 && 
              <Badge 
                badgeContent={enabledFilters.filter(Boolean).length}
                sx={{
                  ml: 2,
                  mr: .5,
                  '& .MuiBadge-badge' : {
                    display: 'grid',
                    background: '#00CECF',
                    color:'white',
                  },
                }}
              />
          }
        </Typography>
      </Button>

      <Popover
        sx={{ marginTop: '5px' }}
        open={enabledFiltersOpen}
        anchorEl={enabledFiltersAnchorEl}
        onClose={handleEnabledFilterClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '246px',
            maxHeight: '400px',
            overflow: 'auto',
            borderRadius: '6px',
            backgroundColor: '#FFF',
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          { children }
        </div>
      </Popover>
    </>
  );
};


export default FilterComponent;